import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { TabView, TabPanel } from "primereact/tabview";
import { Avatar } from "primereact/avatar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { userService } from "../../services/UserService";
import { useAuth } from "../../context/AuthContext";

export default function ProfilePage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const toast = useRef(null);
  const { setToken } = useAuth();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    address: "",
    role: "",
    tenantName: "",
    tenantPhone: "",
    tenantAddress: "",
    tenantReceiptNote: ""
  });

  const [passwordDialog, setPasswordDialog] = useState(false);
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [tenantUsers, setTenantUsers] = useState([]);
  const [tenantUsersLoading, setTenantUsersLoading] = useState(false);
  const [newUserDialog, setNewUserDialog] = useState(false);
  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    address: "",
    role: null,
    password: ""
  });

  useEffect(() => {
    fetchProfile();
    fetchTenantUsers();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await userService.getProfile();
      if (res.data.success) {
        setProfile(res.data.data);
      }
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Profil bilgileri yüklenemedi",
        life: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  const handleProfileUpdate = async () => {
    if (!profile.fullName || !profile.email) {
      toast.current.show({
        severity: "warn",
        summary: "Eksik Bilgi",
        detail: "Ad Soyad ve E-posta alanları zorunludur.",
        life: 3000
      });
      return;
    }

    try {
      const res = await userService.updateProfile(profile);
      if (res.data.success) {
        toast.current.show({
          severity: "success",
          summary: "Başarılı",
          detail: "Profil başarıyla güncellendi",
          life: 3000
        });

        // Update local auth state with new token
        const newToken = res.data.data.token;
        localStorage.setItem("token", newToken);
        setToken(newToken);
        // AuthProvider will decode and set user in useEffect
      } else {
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: res.data.message,
          life: 3000
        });
      }
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Profil güncellenirken bir hata oluştu",
        life: 3000
      });
    }
  };

  const fetchTenantUsers = async () => {
    try {
      setTenantUsersLoading(true);
      const res = await userService.getTenantUsers();
      if (res.data.success) {
        setTenantUsers(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setTenantUsersLoading(false);
    }
  };

  const handleAddTenantUser = async () => {
    if (!newUser.fullName || !newUser.email || !newUser.password || !newUser.role) {
      toast.current.show({
        severity: "warn",
        summary: "Eksik Bilgi",
        detail: "Ad Soyad, E-posta, Şifre ve Rol alanları zorunludur.",
        life: 3000
      });
      return;
    }

    try {
      const res = await userService.addTenantUser(newUser);
      if (res.data.success) {
        toast.current.show({
          severity: "success",
          summary: "Başarılı",
          detail: "Kullanıcı başarıyla eklendi",
          life: 3000
        });
        setNewUserDialog(false);
        setNewUser({ fullName: "", email: "", phoneNumber: "", address: "", role: "Sales", password: "" });
        fetchTenantUsers();
      } else {
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: res.data.message,
          life: 3000
        });
      }
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Kullanıcı eklenirken bir hata oluştu",
        life: 3000
      });
    }
  };

  const handleChangePassword = async () => {
    if (!passwords.currentPassword || !passwords.newPassword || !passwords.confirmPassword) {
      toast.current.show({
        severity: "warn",
        summary: "Eksik Bilgi",
        detail: "Tüm şifre alanlarını doldurun.",
        life: 3000
      });
      return;
    }

    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.current.show({
        severity: "warn",
        summary: "Hata",
        detail: "Yeni şifreler eşleşmiyor.",
        life: 3000
      });
      return;
    }

    try {
      const res = await userService.changePassword({
        currentPassword: passwords.currentPassword,
        newPassword: passwords.newPassword
      });

      if (res.data.success) {
        toast.current.show({
          severity: "success",
          summary: "Başarılı",
          detail: "Şifre başarıyla değiştirildi",
          life: 3000
        });
        setPasswordDialog(false);
        setPasswords({ currentPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Hata",
          detail: res.data.message,
          life: 3000
        });
      }
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Şifre değiştirilirken bir hata oluştu",
        life: 3000
      });
    }
  };

  return (
    <div className="p-2 md:p-3 bg-gray-50/50 min-h-screen">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      {loading ? (
        <div className="flex justify-center items-center h-[calc(100vh-100px)]">
          <div className="text-center">
            <i className="pi pi-spin pi-spinner text-4xl text-blue-600 mb-3"></i>
            <p className="text-gray-500 font-medium">Profil yükleniyor...</p>
          </div>
        </div>
      ) : (
        <div className="max-w-5xl mx-auto">
        {/* Modern Header Section */}
        <div className="relative mb-6 bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="h-32 bg-gradient-to-r from-blue-600 to-indigo-700 relative flex items-center">
             <div className="px-6 w-full">
                <div className="flex flex-col md:flex-row md:items-center gap-6 translate-y-4 md:translate-y-0">
                    <div className="hidden md:block w-32"></div> {/* Spacer for Avatar alignment */}
                    <div className="flex-1 min-w-0">
                        <h1 className="text-2xl md:text-3xl font-black text-white tracking-tight drop-shadow-lg truncate">
                            {profile.fullName}
                        </h1>
                        <div className="flex flex-wrap items-center gap-3 mt-2 opacity-90">
                           <span className="flex items-center gap-2 text-xs font-bold text-white/90 bg-white/10 backdrop-blur-md px-2.5 py-1 rounded-lg border border-white/10">
                             <i className="pi pi-envelope text-white"></i>
                             {profile.email}
                           </span>
                           <span className="flex items-center gap-2 text-xs font-bold text-white/90 bg-white/10 backdrop-blur-md px-2.5 py-1 rounded-lg border border-white/10">
                             <i className="pi pi-building text-white"></i>
                             {profile.tenantName}
                           </span>
                           <span className="hidden lg:inline-flex items-center px-2.5 py-1 rounded-lg text-[9px] font-black bg-white/20 text-white uppercase tracking-widest border border-white/20">
                             {profile.role}
                           </span>
                        </div>
                    </div>
                </div>
             </div>
          </div>
          <div className="px-6 pb-6 relative">
            <div className="flex flex-col md:flex-row items-center md:items-end gap-6 -mt-16 md:-mt-12">
              <div className="relative z-10 shrink-0">
                <Avatar
                  label={profile.fullName.charAt(0)}
                  size="xlarge"
                  className="w-28 h-28 md:w-32 md:h-32 !rounded-3xl border-4 border-white shadow-xl !bg-white !text-blue-600 !text-4xl md:text-5xl !font-bold"
                />
              </div>
              <div className="flex-1 text-center md:text-left pb-1 min-w-0">
                {/* Mobile Name & Labels */}
                <div className="md:hidden mt-4">
                    <h1 className="text-xl font-bold text-gray-900 truncate mb-2">{profile.fullName}</h1>
                    <div className="flex flex-wrap justify-center gap-2 mb-3">
                        <span className="px-2 py-0.5 rounded-lg bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-wider">
                           {profile.role}
                        </span>
                    </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto mt-3 md:mt-0 pb-1 shrink-0">
                <Button
                  label="Şifre Değiştir"
                  icon="pi pi-key"
                  className="p-button-sm p-button-outlined p-button-warning !rounded-xl !py-2 px-4 font-semibold transition-all hover:bg-orange-50"
                  onClick={() => setPasswordDialog(true)}
                />
                <Button
                  label="Yeni Kullanıcı Ekle"
                  icon="pi pi-user-plus"
                  className="p-button-sm p-button-outlined p-button-info !rounded-xl !py-2 px-4 font-semibold transition-all hover:bg-blue-50"
                  onClick={() => setNewUserDialog(true)}
                />
                <Button
                  label="Kaydet"
                  icon="pi pi-save"
                  className="p-button-sm p-button-primary !rounded-xl shadow-md shadow-blue-200 !py-2 px-4 font-semibold transition-all transform hover:-translate-y-0.5"
                  onClick={handleProfileUpdate}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Content Tabs */}
        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
          <TabView className="profile-tabs">
            <TabPanel header="Kişisel Bilgiler" leftIcon="pi pi-user mr-2 text-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 p-4">
                <div className="space-y-4">
                  <div className="field">
                    <label htmlFor="fullName" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">Ad Soyad</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-user text-blue-500 text-sm" />
                      </span>
                      <InputText
                        id="fullName"
                        value={profile.fullName}
                        onChange={(e) => setProfile({ ...profile, fullName: e.target.value })}
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                        placeholder="Adınızı ve soyadınızı giriniz"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="email" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">E-posta Adresi</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-envelope text-blue-500 text-sm" />
                      </span>
                      <InputText
                        id="email"
                        value={profile.email}
                        onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                        placeholder="E-posta adresinizi giriniz"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="phone" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">Telefon Numarası</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-phone text-blue-500 text-sm" />
                      </span>
                      <InputMask
                        id="phone"
                        value={profile.phoneNumber}
                        mask="0(999) 999 99 99"
                        onChange={(e) => setProfile({ ...profile, phoneNumber: e.value })}
                        placeholder="0(5xx) xxx xx xx"
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                      />
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="address" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">Kişisel Adres</label>
                  <InputTextarea
                    id="address"
                    value={profile.address}
                    onChange={(e) => setProfile({ ...profile, address: e.target.value })}
                    rows={8}
                    autoResize
                    className="w-full !rounded-xl !border-gray-200 !p-3 focus:!ring-2 focus:!ring-blue-100 transition-all h-full text-sm"
                    placeholder="Adres bilgilerinizi buraya yazabilirsiniz..."
                  />
                </div>
              </div>
            </TabPanel>

            <TabPanel header="Şirket Bilgileri" leftIcon="pi pi-building mr-2 text-sm">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 p-4">
                <div className="space-y-4">
                  <div className="field">
                    <label htmlFor="tenantName" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">İşletme / Şirket Ünvanı</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-id-card text-blue-500 text-sm" />
                      </span>
                      <InputText
                        id="tenantName"
                        value={profile.tenantName}
                        onChange={(e) => setProfile({ ...profile, tenantName: e.target.value })}
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                        placeholder="Şirketinizin resmi ünvanını giriniz"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="tenantPhone" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">İşletme Telefonu</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-phone text-blue-500 text-sm" />
                      </span>
                      <InputMask
                        id="tenantPhone"
                        value={profile.tenantPhone}
                        mask="0(999) 999 99 99"
                        onChange={(e) => setProfile({ ...profile, tenantPhone: e.value })}
                        placeholder="0(xxx) xxx xx xx"
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="tenantReceiptNote" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">Fiş Alt Notu (Sabit)</label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon !bg-gray-50 !border-gray-200 !rounded-l-xl !py-2 px-3">
                        <i className="pi pi-file-edit text-blue-500 text-sm" />
                      </span>
                      <InputText
                        id="tenantReceiptNote"
                        value={profile.tenantReceiptNote}
                        onChange={(e) => setProfile({ ...profile, tenantReceiptNote: e.target.value })}
                        className="!rounded-r-xl !border-gray-200 !py-2.5 text-sm"
                        placeholder="Fişlerin altında görünecek sabit not"
                      />
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="tenantAddress" className="font-bold text-gray-700 block mb-1.5 ml-1 text-sm">İşletme Adresi</label>
                  <InputTextarea
                    id="tenantAddress"
                    value={profile.tenantAddress}
                    onChange={(e) => setProfile({ ...profile, tenantAddress: e.target.value })}
                    rows={8}
                    autoResize
                    className="w-full !rounded-xl !border-gray-200 !p-3 focus:!ring-2 focus:!ring-blue-100 transition-all h-full text-sm"
                    placeholder="Şirket merkez adresini buraya yazabilirsiniz..."
                  />
                </div>
              </div>
            </TabPanel>

            <TabPanel header="Şirkete Ait Kullanıcılar" leftIcon="pi pi-users mr-2 text-sm">
              <div className="p-3">
                <DataTable
                  value={tenantUsers}
                  loading={tenantUsersLoading}
                  rows={10}
                  className="p-datatable-sm"
                  emptyMessage="Şirkete ait başka kullanıcı bulunamadı."
                  responsiveLayout="stack"
                >
                  <Column field="fullName" header="Ad Soyad" sortable style={{ minWidth: '12rem' }} />
                  <Column field="email" header="E-posta" sortable style={{ minWidth: '12rem' }} />
                  <Column field="phoneNumber" header="Telefon" style={{ minWidth: '10rem' }} />
                  <Column field="role" header="Rol" style={{ minWidth: '8rem' }} />
                  <Column
                    header="Kayıt Tarihi"
                    body={(row) => new Date(row.createdDate).toLocaleDateString('tr-TR')}
                    sortable
                    style={{ minWidth: '10rem' }}
                  />
                </DataTable>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      )}

      <Dialog
        header="Yeni Kullanıcı Ekle"
        visible={newUserDialog}
        onHide={() => setNewUserDialog(false)}
        className="w-full max-w-lg"
        footer={
          <div className="flex justify-end gap-2">
            <Button label="İptal" icon="pi pi-times" className="p-button-text p-button-sm" onClick={() => setNewUserDialog(false)} />
            <Button label="Kaydet" icon="pi pi-check" className="p-button-sm" onClick={handleAddTenantUser} />
          </div>
        }
      >
        <div className="flex flex-col gap-4 p-fluid mt-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="field">
              <label className="font-bold mb-2 block">Ad Soyad</label>
              <InputText
                value={newUser.fullName}
                onChange={(e) => setNewUser({ ...newUser, fullName: e.target.value })}
                placeholder="Ad Soyad"
              />
            </div>
            <div className="field">
              <label className="font-bold mb-2 block">E-posta</label>
              <InputText
                value={newUser.email}
                onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                placeholder="E-posta adresi"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-2">
            <div className="field">
              <label className="font-bold mb-2 block">Rol</label>
              <Dropdown
                value={newUser.role}
                options={[
                  { label: "Yönetici", value: "Admin" },
                  { label: "Satış Kullanıcısı", value: "Sales" },
                ]}
                onChange={(e) => setNewUser({ ...newUser, role: e.value })}
                placeholder="Rol Seçin"
                appendTo="self"
              />
            </div>
            <div className="field">
              <label className="font-bold mb-2 block">Adres</label>
              <InputTextarea
                value={newUser.address}
                onChange={(e) => setNewUser({ ...newUser, address: e.target.value })}
                rows={1}
                autoResize
                placeholder="Adres bilgisi (Opsiyonel)"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-2">
            <div className="field">
              <label className="font-bold mb-2 block">Telefon</label>
              <InputMask
                value={newUser.phoneNumber}
                mask="0(999) 999 99 99"
                onChange={(e) => setNewUser({ ...newUser, phoneNumber: e.value })}
                placeholder="0(5xx) xxx xx xx"
              />
            </div>
            <div className="field">
              <label className="font-bold mb-2 block">Şifre</label>
              <Password
                value={newUser.password}
                onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                toggleMask
                feedback={false}
                placeholder="Başlangıç şifresi"
              />
            </div>
          </div>
          
        </div>
      </Dialog>

      <Dialog
        header="Şifre Değiştir"
        visible={passwordDialog}
        onHide={() => setPasswordDialog(false)}
        className="w-full max-w-md"
        footer={
          <div className="flex justify-end gap-2">
            <Button label="İptal" icon="pi pi-times" className="p-button-text p-button-sm" onClick={() => setPasswordDialog(false)} />
            <Button label="Güncelle" icon="pi pi-check" className="p-button-sm" onClick={handleChangePassword} />
          </div>
        }
      >
        <div className="flex flex-col gap-4 p-fluid mt-2">
          <div className="field">
            <label className="font-bold mb-2 block">Mevcut Şifre</label>
            <Password
              value={passwords.currentPassword}
              onChange={(e) => setPasswords({ ...passwords, currentPassword: e.target.value })}
              toggleMask
              feedback={false}
            />
          </div>
          <Divider />
          <div className="field">
            <label className="font-bold mb-2 block">Yeni Şifre</label>
            <Password
              value={passwords.newPassword}
              onChange={(e) => setPasswords({ ...passwords, newPassword: e.target.value })}
              toggleMask
            />
          </div>
          <div className="field">
            <label className="font-bold mb-2 block">Yeni Şifre (Tekrar)</label>
            <Password
              value={passwords.confirmPassword}
              onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })}
              toggleMask
              feedback={false}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
